var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.792 3.815a.75.75 0 0 1 1.085 1.035l-7 7.334a.75.75 0 0 1-1.085 0l-1.4-1.465a.75.75 0 0 1-.166.75l-.682.715a.75.75 0 0 1-1.03.052l-.055-.052L1.125 9.74l-.05-.058a.75.75 0 0 1 1.08-1.03l.056.053L4 10.58l.14-.147a.75.75 0 0 1 .802-.185l-.485-.509-.05-.058a.75.75 0 0 1 1.08-1.03l.056.053 1.79 1.876z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.515 3.762a.75.75 0 0 1 1.029 1.088L7.502 9.085l-.056.052a.75.75 0 0 1-1.03-1.087l4.043-4.235z"
  })));
};
export default Svg16;